import { ChangeEvent, memo, useCallback, useMemo } from "react";
import { Column, IntegratedSorting, SortingState } from "@devexpress/dx-react-grid";
import { Grid, Table, TableHeaderRow } from "@devexpress/dx-react-grid-bootstrap4";
import { CurrencyEntity } from "../domain/currency.entity";
import { injectIntl, IntlShape } from "react-intl";
import { tableHeaderMessages } from "../messages";

export interface CurrencyTableProps {
  rows: CurrencyEntity[];
  intl: IntlShape;
  onChange: (event: ChangeEvent<HTMLInputElement>, row: CurrencyEntity) => void;
}

const VisibleComponent = ({
  row,
  onChange,
}: {
  row: CurrencyEntity;
  onChange: (event: ChangeEvent<HTMLInputElement>, row: CurrencyEntity) => void;
}) => (
  <td>
    <input type="checkbox" checked={row.visible} onChange={event => onChange(event, row)} />
  </td>
);

function _CurrencyTable({ rows, onChange, intl }: CurrencyTableProps) {
  const columns: Column[] = useMemo(
    () => [
      {
        name: "code",
        title: intl.formatMessage(tableHeaderMessages.code),
      },
      {
        name: "name",
        title: intl.formatMessage(tableHeaderMessages.name),
      },

      {
        name: "visible",
        title: intl.formatMessage(tableHeaderMessages.visible),
      },
    ],
    []
  );

  const cellComponent = useCallback(props => {
    const { column } = props;
    if (column.name === "visible") {
      return <VisibleComponent row={props.row} onChange={onChange} />;
    }
    return <Table.Cell {...props} />;
  }, []);
  return (
    <Grid rows={rows} columns={columns}>
      <SortingState defaultSorting={[{ columnName: "code", direction: "asc" }]} />
      <IntegratedSorting />
      <Table cellComponent={cellComponent} />
      <TableHeaderRow showSortingControls />
    </Grid>
  );
}

export const CurrencyTable = memo(injectIntl(_CurrencyTable));
